import { forwardRef } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useLocation, useMatch } from 'react-router-dom';

import { IconErrorSmall } from '@components/icons/error-small';
import { Stack } from '@components/stack';

import { useApplicationTabs } from 'hooks/useApplicationTabs';
import { Tab, TabList, useTabState } from 'components/Tabs';

export const ApplicationTabs = observer(
  forwardRef(({ application, border = false }, ref) => {
    const section = useMatch('/jobs/:jobID/application/:applicationID/:section')?.params.section;
    const loc = useLocation();
    const tabs = useApplicationTabs(application);
    const sectionTabIndex = tabs.findIndex((item) => item.value === section);
    const tabId = sectionTabIndex > 0 ? sectionTabIndex : 0;
    const tabState = useTabState({ selectedId: tabId });
    const addOnClose = loc && loc.state && loc.state.onCloseUrl;

    return (
      <TabList
        state={tabState}
        border={border}
        ref={ref}
        collapseOnMobile
        label="Application sections"
      >
        {tabs.map((tab) => (
          <Tab
            data-cy={'application-tabs:' + tab.value}
            key={tab.value}
            link={
              addOnClose
                ? { pathname: tab.link, state: { onCloseUrl: loc.state.onCloseUrl } }
                : tab.link
            }
          >
            <Stack orientation="horizontal" align="center" space={1}>
              {tab.icon}
              {tab.display}
              {tab.error ? <IconErrorSmall color="red100" /> : null}
              {tab.count ? <Value active={tab.activeCount}>{tab.count}</Value> : null}
            </Stack>
          </Tab>
        ))}
      </TabList>
    );
  })
);

const Value = styled.div((p) => ({
  minHeight: '1rem',
  minWidth: '1rem',
  borderRadius: '0.125rem',
  backgroundColor: p.theme.colors.purpleTrans10,
  color: p.theme.colors.purple80,
  ...p.theme.text.semibold10,
  padding: '0.125rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...(p.active && {
    color: p.theme.colors.white100,
    backgroundColor: p.theme.colors.green100,
  }),
}));
